import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';

angular.module('webTools').controller('WorkflowCtrl', ['$scope', '$rootScope', '$location', '$routeParams', '$route', '$timeout', 'MenuBuilder', 'Columns', 'GridTools', 'ModalWindow', '$ngRedux',
	function ($scope, $rootScope, $location, $routeParams, $route, $timeout, MenuBuilder, Columns, GridTools, ModalWindow, $ngRedux) {

		const state = $ngRedux.getState();

		$scope.kendo = $scope.kendo || {};
		$scope.gridName = 'workflowGrid';
		$scope.breadcrumb = [];

		$scope.rightClickMenu = false;
		$scope.selectedItems = [];
		$scope.selectedId = '';

		$scope.showMessageMenuArrow = false;
		$scope.showMessageMenu = false;

		$rootScope.workingFolder = $routeParams.view ? $routeParams.view : 'messages';

		$scope.data = {
			workingFolder: $routeParams.view ? $routeParams.view : 'messages',
			view: 'workflow'
		};

		if (!$routeParams.page) {
			$location.search('page', 1);
			window.history.replaceState({}, '', $location.url());
		}

		$scope.getMargin = view => {
			let margin = 0;

			switch ($routeParams.view.toLowerCase()) {
				case 'messages':
					margin = 420;
					break;
				case 'tasks':
					margin = 575;
					break;
				case 'history':
					margin = 535;
					break;
				default:
					break;
			}

			return margin;
		}

		$scope.dialogWidth = $scope.getMargin($rootScope.workingFolder);

		// set breadcrumb
		$scope.setBreadcrumb = () => {
			let bc = [];

			switch ($routeParams.view.toLowerCase()) {
				case 'messages':
					bc = [{ path: '/workflow?view=messages', breadcrumbName: 'Messages' }];
					break;
				case 'tasks':
					bc = [{ path: '/workflow?view=tasks', breadcrumbName: 'Workflow Tasks' }];
					break;
				case 'history':
					bc = [{ path: '/workflow?view=history', breadcrumbName: 'Workflow History' }];
					break;
				default:
					break;
			}

			$scope.breadcrumb = bc;
		}

		$scope.setBreadcrumb();

		$scope.$on('$routeUpdate', function (e, data) {

			$routeParams.view && $scope.selectView($routeParams.view);

			$scope.setBreadcrumb();
			$scope.dialogWidth = $scope.getMargin();

			$scope.data = {
				workingFolder: $routeParams.view ? $routeParams.view : 'messages',
				view: 'workflow'
			};

			$scope.menuOptions = [];

		});

		if ($routeParams.view === 'messages') {
			$scope.$on('gridLoaded', function (e) {
				// refresh menu options if there are no selected items
				if ($scope.selectedItems.length !== 0) {
					$scope.$emit('selectedItemsUpdated', $scope.selectedItems);
					$scope.$apply()
				}
			});
		}


		if ($routeParams.taskId) {

			$scope.taskId = $routeParams.taskId;

			if ($routeParams.page !== 0) {

				var loaded = $scope.$on('gridLoaded', function () {
					var wtObject = _.find($scope.kendo[$scope.gridName]._data, function (ds) { return ds.ID === $scope.taskId; });

					$scope.$broadcast('loadLegacyDialog', $rootScope.workingFolder, wtObject);

					if (!$scope.dialogPaneIsOpen) {
						angular.element('#details-pane').css({ 'display': 'block' })
						$timeout(() => angular.element('#details-pane').css({ 'margin-right': 0 }), 100)
						$scope.dialogPaneIsOpen = true;
						$scope.$apply();
					}

					$scope.kendo.selectGridItem(wtObject.ID);

					loaded();
				})
			} else {
				$location.search('page', 1);
				ModalWindow.openNotification('The task you are attempting to navigate to does not exist in this repository.');

			}
		}

		$scope.selectView = function (view) {
			if ($rootScope.workingFolder !== view) {

				switch (view) {
					case 'messages':
						$scope.workflowGridOptions.allowRowSelect = true;
						$scope.workflowGridOptions.allowMultiselect = true;
						$scope.workflowGridOptions.enableContextMenu = true;
						$scope.gridData = messageData;
						break;
					case 'tasks':
						$scope.workflowGridOptions.allowRowSelect = true;
						$scope.workflowGridOptions.allowMultiselect = false;
						$scope.workflowGridOptions.enableContextMenu = false;
						$scope.gridData = taskData;
						break;
					case 'history':
						$scope.workflowGridOptions.allowRowSelect = true;
						$scope.workflowGridOptions.allowMultiselect = false;
						$scope.workflowGridOptions.enableContextMenu = false;
						$scope.gridData = taskHistoryData;
						break;
					default:
						break;
				}

				$rootScope.workingFolder = view;
				$location.search({ view: view });
				$scope.selectedId = '';
				$scope.$broadcast('reloadGrid');
				$scope.closeDialogPane();
			}
		}

		$scope.userView = function () { return Columns.isUserView(); };

		$scope.resetColumns = function () {
			$scope.$broadcast('hideGrid');
			Columns.resetColumns($rootScope.workingFolder, function () { $scope.selectedId = ''; $scope.$broadcast('reloadGrid'); });
		};

		var wtObject = {};
		$scope.dialogPaneIsOpen = false;

		$scope.$on('gridItemSelected', function (e, data) {

			if (data.openDetails) {
				if (!$scope.dialogPaneIsOpen) {
					angular.element('#details-pane').css({ 'display': 'block' })
					$timeout(() => angular.element('#details-pane').css({ 'margin-right': 0 }), 100)
					$scope.dialogPaneIsOpen = true;
				}

				wtObject = GridTools.getObjectFromGrid(data.id, $scope.kendo[$scope.gridName]._data);
				$scope.$broadcast('loadLegacyDialog', $rootScope.workingFolder, wtObject)

				if (wtObject.MessageRead === '0') {
					$rootScope.$broadcast('markRead', data.id);
					$timeout($scope.menuOptions = MenuBuilder.getMessageContextMenu($scope.selectedItems, $scope.kendo[$scope.gridName]._data));
				}
				
			} else {
				if (data.id !== $scope.selectedId && $scope.dialogPaneIsOpen) {
					$scope.selectedId = data.id;
					wtObject = GridTools.getObjectFromGrid(data.id, $scope.kendo[$scope.gridName]._data);
	
					if (wtObject.MessageRead === '0') {
						$rootScope.$broadcast('markRead', data.id);
						$timeout($scope.menuOptions = MenuBuilder.getMessageContextMenu($scope.selectedItems, $scope.kendo[$scope.gridName]._data));
					}
	
					$scope.$broadcast('loadLegacyDialog', $rootScope.workingFolder, wtObject)
				}
			}
		});

		$scope.closeDialogPane = function () {
			if ($scope.dialogPaneIsOpen) { angular.element('#details-pane').css({ 'margin-right': -$scope.getMargin() + 'px' }) }
			$scope.selectedId = '';
			$scope.dialogPaneIsOpen = false;
		};

		$scope.closeDialog = function () {
			$scope.closeDialogPane();
			$scope.selectedId = '';
			$scope.$broadcast('reloadGrid');
		};

		$scope.showMenu = function () {
			$scope.showMessageMenu = $scope.selectedItems.length > 0 && $scope.showMessageMenu === false ? true : false;
		}

		$scope.hideMenu = function () {
			$scope.showMessageMenu = false;
		}

		$scope.$on('selectedItemsUpdated', function (e, selectedItems) {
			
			if (selectedItems.length === 0) { $scope.closeDialogPane() }
			$scope.selectedItems = selectedItems;
			if (selectedItems.length > 0 && $routeParams.view !== 'tasks' && $routeParams.view !== 'history') {
				$scope.menuOptions = MenuBuilder.getMessageContextMenu(selectedItems, $scope.kendo[$scope.gridName]._data);
			} else {
				$scope.menuOptions = [];
			}
		});

		$scope.getColumns = function () { return Columns.getWorkflowColums($rootScope.workingFolder); };

		$scope.workflowGridOptions = {
			mainGrid: true,
			loadOnInit: true,
			allowRowSelect: true,
			allowMultiselect: true,
			allowColumnState: true,
			allowSelectFolders: false,
			enableContextMenu: true,
			columnMenu: true,
			sortable: true,
			resizable: true,
			reorderable: true,
			scrollable: true,
			responsive: true,
			pageable: {
				info: true,
				refresh: false
			}
		};

		const endpoint = state.app.endpoint;

		var messageData = {
			transport: {
				read: {
					url: `${endpoint ? endpoint : ''}/api/messages/getmessages/?nocache=` + new Date().getTime(),
					contentType: 'application/json'
				},
				parameterMap: function (data, operation) {

					if (data.sort && data.sort.length > 0) {
						const sort = { sortField: data.sort[0].field, sortDirection: data.sort[0].dir };
						
						if (operation === 'read') { delete data.sort; data = $.extend(sort, data); }
					}

					data = $.extend({ folderID: $rootScope.workingFolder }, data);

					return data;
				}
			},
			schema: {
				data: 'Data',
				total: 'TotalRows'
			},
			serverPaging: true,
			serverSorting: true,
			pageSize: 50,
			page: 1,
			sort: $scope.gridSort
		};

		var taskData = {
			transport: {
				read: {
					url: `${endpoint ? endpoint : ''}/api/Workflow/gettasks?nocache=` + new Date().getTime(),
					contentType: 'application/json'
				},
				parameterMap: function (data, operation) {

					if (data.sort && data.sort.length > 0) {
						const sort = { sortField: data.sort[0].field, sortDirection: data.sort[0].dir };
						
						if (operation === 'read') { delete data.sort; data = $.extend(sort, data); }
					}

					data = $.extend({ folderID: $rootScope.workingFolder }, data);

					return data;
				}
			},
			schema: {
				data: 'Data',
				total: 'TotalRows'
			},
			serverPaging: true,
			serverSorting: true,
			pageSize: 50,
			page: 1,
			sort: $scope.gridSort
		};

		var taskHistoryData = {
			transport: {
				read: {
					url: `${endpoint ? endpoint : ''}/api/workflow/gettaskhistory/?nocache=` + new Date().getTime(),
					contentType: 'application/json'
				},
				parameterMap: function (data, operation) {

					if (data.sort && data.sort.length > 0) {
						const sort = { sortField: data.sort[0].field, sortDirection: data.sort[0].dir };
						
						if (operation === 'read') { delete data.sort; data = $.extend(sort, data); }
					}

					data = $.extend({ folderID: $rootScope.workingFolder }, data);

					return data;
				}
			},
			schema: {
				data: 'Data',
				total: 'TotalRows'
			},
			serverPaging: true,
			serverSorting: true,
			pageSize: 50,
			page: 1,
			sort: $scope.gridSort
		};

		switch ($routeParams.view) {
			case 'tasks':
				$scope.workflowGridOptions.allowRowSelect = true;
				$scope.workflowGridOptions.allowMultiselect = false;
				$scope.workflowGridOptions.enableContextMenu = false;
				$scope.gridData = taskData;
				break;
			case 'history':
				$scope.workflowGridOptions.allowRowSelect = true;
				$scope.workflowGridOptions.allowMultiselect = false;
				$scope.workflowGridOptions.enableContextMenu = false;
				$scope.gridData = taskHistoryData;
				break;
			default:
				$scope.workflowGridOptions.allowRowSelect = true;
				$scope.workflowGridOptions.allowMultiselect = true;
				$scope.workflowGridOptions.enableContextMenu = true;
				$scope.gridData = messageData;
				break;
		}

		$scope.$on('launchMessageForward', function (e) {
			if (!$scope.dialogPaneIsOpen) {
				angular.element('#details-pane').css({ 'display': 'block' })
				$timeout(() => angular.element('#details-pane').css({ 'margin-right': 0 }), 100)
				$scope.dialogPaneIsOpen = true;
			}
		});

		$scope.$on('launchMessageReply', function (e) {
			if (!$scope.dialogPaneIsOpen) {
				angular.element('#details-pane').css({ 'display': 'block' })
				$timeout(() => angular.element('#details-pane').css({ 'margin-right': 0 }), 100)
				$scope.dialogPaneIsOpen = true;
			}
		});
	}
]);

angular.module('webTools').directive('wtWorkflowDialog', ['Columns', '$rootScope',
	function (Columns, $rootScope) {
		return {
			restrict: 'E',
			replace: true,
			transclude: false,
			template: '<div id="workflowFrameWrapper" class="workflow-iframe"></div>',
			link: function (scope, element, attributes) {
				scope.$on('loadLegacyDialog', function (e, workingFolder, selectedItems) {

					if (workingFolder === 'messages') {
						element.html('<iframe src="legacy/messageviewer.aspx?eventid=' + selectedItems.ID + '&addressid=' + selectedItems.AddressID + '" id="workflowFrame">');
						return true;
					} else if (workingFolder === 'tasks') {
						element.html('<iframe src="legacy/processstep.aspx?instanceid=' + selectedItems.ID + '&stepnumber=' + selectedItems.StepNumber + '&routeid=' + selectedItems.RouteID + '" id="workflowFrame">');
						return true;
					} else if (workingFolder === 'history') {
						element.html('<iframe src="legacy/workflowdetails.aspx?instanceid=' + selectedItems.ID + '" id="workflowFrame">');
						return true;
					} else if (element.children().length > 0) {
						element.children().remove();
						return false;
					}
				});

				scope.$on('launchMessageForward', function (e) {

					var wtObject = _.find(scope.kendo[scope.gridName]._data, function (ds) { return ds.ID === scope.selectedItems[0].ID; });

					element.html('<iframe src="legacy/messagereply.aspx?eventid=' + wtObject.ID + '&addressid=' + wtObject.AddressID + '&type=reply" id="workflowFrame">');
					$rootScope.$broadcast('markRead');
				});

				scope.$on('launchMessageReply', function (e) {

					var wtObject = _.find(scope.kendo[scope.gridName]._data, function (ds) { return ds.ID === scope.selectedItems[0].ID; });

					element.html('<iframe src="legacy/messagereply.aspx?eventid=' + wtObject.ID + '&addressid=' + wtObject.AddressID + '&type=Reply" id="workflowFrame">');

					$rootScope.$broadcast('markRead');
				});

				scope.$on('launchMessageDelete', function (e) {

					Columns.deleteMessage(_.map(scope.selectedItems, 'ID'));

					_.each(angular.element('.k-grid-content').children().find('.k-state-selected'), function (row) {
						scope.kendo[scope.gridName].removeRow(row);
					})

					scope.selectedId = '';
					$rootScope.$broadcast('reloadGrid');
					scope.closeDialogPane();
				});
			}
		};
	}
]);